var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoreSkillSetMatchingJdDoneIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99993 0C13.9705 0 18 4.02938 18 8.99993C18 13.9706 13.9705 18 8.99993 18C4.02946 18.0001 0 13.9706 0 8.99993C0 4.02938 4.02946 0 8.99993 0ZM4.99596 9.91385L4.99376 9.9118C4.87877 9.80662 4.81695 9.66497 4.80978 9.52083C4.8026 9.37698 4.85006 9.23006 4.95391 9.11404C4.95538 9.11243 4.9567 9.11096 4.95816 9.1095C5.06319 8.99465 5.20484 8.93269 5.34898 8.92551C5.49385 8.91833 5.64165 8.96653 5.75796 9.0717L7.6558 10.7926L12.2098 6.02319C12.3182 5.90952 12.4622 5.85034 12.6081 5.84683C12.7534 5.84316 12.9002 5.89502 13.014 6.00312C13.1278 6.11138 13.1869 6.25581 13.1905 6.40142C13.1942 6.54688 13.1422 6.69395 13.0341 6.80762L8.09744 11.978C8.09407 11.9815 8.09041 11.9849 8.08675 11.9878C7.98202 12.0925 7.8452 12.1482 7.70619 12.1533C7.56351 12.1587 7.41864 12.1104 7.30424 12.0068L4.99771 9.91532L4.99596 9.91385Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreSkillSetMatchingJdDoneIc);
export default __webpack_public_path__ + "static/media/core-skill-set-matching-jd-done-ic.d9a877fbe14762ccfc3e779f354fadd7.svg";
export { ForwardRef as ReactComponent };